export default "/images/a46e2579c413af59ccdcc5ed0bd45294.avif";